import Requests from './RequestsContainer';

export { Requests };



// WEBPACK FOOTER //
// ./src/modules/home/requests/index.js